import { lpControllerManifest } from "./manifest.generated";
const controllerLoaders = lpControllerManifest;
const loadedControllers = new Set();
function loadController(tagName) {
    if (loadedControllers.has(tagName)) {
        return;
    }
    loadedControllers.add(tagName);
    void controllerLoaders[tagName]();
}
function loadControllersIn(root) {
    Object.keys(controllerLoaders).forEach((tagName) => {
        if (root instanceof Element && root.matches(tagName)) {
            loadController(tagName);
            return;
        }
        if (root.querySelector(tagName)) {
            loadController(tagName);
        }
    });
}
if (Object.keys(controllerLoaders).length > 0) {
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", () => loadControllersIn(document), { once: true });
    }
    else {
        loadControllersIn(document);
    }
    new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
                if (node instanceof Element) {
                    loadControllersIn(node);
                }
            });
        });
    }).observe(document.documentElement, { childList: true, subtree: true });
}
